// extracted by mini-css-extract-plugin
export default {"home":"c-i_cU","home__background":"c-i_cV","home__content":"c-i_cW"};